<lla-main-menu
  [forDesktop]="false"
  [mainMenuRoutes]="data.items"
  (menuItemClicked)="bottomSheetRef.dismiss()"
></lla-main-menu>
